import { render, staticRenderFns } from "./HandPain.vue?vue&type=template&id=4fe18666&"
import script from "./HandPain.vue?vue&type=script&lang=js&"
export * from "./HandPain.vue?vue&type=script&lang=js&"
import style0 from "./HandPain.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports